export default "__VITE_ASSET__aea68b46__"